// removed by extract-text-webpack-plugin
module.exports = {"PaginationWrap":"_2cdOWLVh1FE9dEpwcwyLlw","CategoryGroup":"_1QSowMw_u_LBtEsj_P6ECg","SubCategory":"QnmhUZsrtr3PMmffTtUHS","ActiveLink":"_2aZtl1y6moeXzrSmLDmcOe","FiltersToggle":"_1Rbr3VZ1v7kYonp9roTziu","MainColumn":"_2DkP5gO4_nMGgfmH99Afdh","SidebarColumn":"_2ZjoROPZlSIHflHh5p-nCu","Card":"_2xVlI5h8Ll2UacRmUhRRCD","EmptyChart":"_21Pcsaq3Ef1p-wc73ln874","containerFluid":"fwlpGxaUzr7LhFvg0vurV","container-fluid":"_1lXIWfqonpDFt9RMuC5zbb"};


//////////////////
// WEBPACK FOOTER
// ./src/PagesOfUser/Transactions/styles.module.css
// module id = 209
// module chunks = 0